import { useAuthenticationService } from '@/services/authentication/authentication-service';
import { Role } from '@/services/authentication/authentication.types';
import { useCallback } from 'react';

export const useStartTenantAdminDelegation = () => {
  const startDelegation = useAuthenticationService(state => state.startDelegation);

  return useCallback(
    async (targetTenantId: string, targetTenantName: string) => {
      await startDelegation(targetTenantId, targetTenantName, Role.Admin);
    },
    [startDelegation]
  );
};
